import en from "./messages/en.json";
import sv from "./messages/sv.json";

export const LOCALES = ["en", "sv"] as const;
export type Locale = (typeof LOCALES)[number];
export const LOCALE_LABELS: Record<Locale, string> = {
	en: "English",
	sv: "Svenska",
};

export const STORAGE_KEY = "platform-locale";
export const TIME_ZONE = "Europe/Stockholm";
export const messages = { en, sv };

export type Messages = typeof en;

const isLocale = (v: unknown): v is Locale => LOCALES.includes(v as Locale);

export function initialLocale(): Locale {
	const stored = localStorage.getItem(STORAGE_KEY);
	if (isLocale(stored)) return stored;
	const browser = navigator.language?.slice(0, 2).toLowerCase();
	return isLocale(browser) ? browser : "en";
}
